import { TextField } from '@mui/material';
import { Controller, get, useFormContext } from 'react-hook-form';

interface MuiInputControlledProps {
  inputProps: {
    name: string;
    defaultValue?: string;
    label?: string;
    placeholder?: string;
  };
  styles?: any;
}

export function MuiInputControlled({
  inputProps,
  styles = {},
}: MuiInputControlledProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = get(errors, inputProps.name);

  return (
    <Controller
      control={control}
      name={inputProps.name}
      defaultValue={inputProps.defaultValue ?? ''}
      render={({ field }) => (
        <TextField
          id={inputProps.name}
          label={inputProps.label ?? ''}
          helperText={error ? String(error?.message) : ''}
          variant="outlined"
          placeholder={inputProps.placeholder ?? ''}
          error={!!error}
          {...field}
          {...inputProps}
          sx={styles}
        />
      )}
    />
  );
}
